import { ApiService } from "./AbstractApiService";
import qs from "qs";
import { IPageModel } from "@/interfaces/iPageModel";

export class ScheduleApi extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: ScheduleApi | null;
  constructor() {
    super("");
  }

  public async createSchedule(
    payload: Record<string, string | number>
  ): Promise<IPageModel<any>> {
    return this.post("document/documents", payload).then(
      (response) => response.data
    );
  }

  public async sendNotification(payload: any): Promise<any> {
    return this.post("notification/send/notificationByToken", payload).then(
      (response) => response.data
    );
  }

  public async createConversation(payload: any, id): Promise<any> {
    if (id) {
      return this.put(`notification/conversations/${id}`, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("notification/conversations", payload).then(
        (response) => response.data
      );
    }
  }

  public async createConversationLink(payload: any): Promise<any> {
    return this.post("notification/documentConversations", payload).then(
      (response) => response.data
    );
  }

  public async deleteConversation(id: any): Promise<any> {
    return this.delete(`notification/conversations/${id}`).then(
      (response) => response.data
    );
  }

  public async updateSchedule(
    payload: Record<string, string | number>
  ): Promise<IPageModel<any>> {
    return this.put(`document/documents/${payload.webId}`, payload).then(
      (response) => response.data
    );
  }

  public async getSchedulesList(
    params?: Record<string, string | number>
  ): Promise<any> {
    return this.get("document/scheduling", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getAllScheduleDocuments(
    params?: Record<string, string | number>
  ): Promise<any> {
    return this.get("document/schedule", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getScheduledDocuments(
    params?: Record<string, string | number>
  ): Promise<any> {
    return this.get("document/scheduled", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getExpiredDocuments(
    params?: Record<string, string | number>
  ): Promise<any> {
    return this.get("document/expired", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getOntimeDocuments(
    params?: Record<string, string | number>
  ): Promise<any> {
    return this.get("document/onTime", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async getOutsidePeriodDocuments(
    params?: Record<string, string | number>
  ): Promise<any> {
    return this.get("document/outsidePeriod", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getResourceList(
    params?: Record<string, string | number>
  ): Promise<any> {
    return this.get("site/userSites/schedule", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
}
